export default [
    {
        key: 'multiple',
        ignore: true
    },
    {
        key: 'defaultValue',
        ignore: true
    },
    {
        label: 'Submit Data to the Server',
        type: 'checkbox',
        input: true,
        key: 'isSubmitData',
        weight: 700,
        defaultValue: false,
        tooltip: 'When enabled, the data from the Data Table will be submitted to the server',
        customConditional: 'show = !_.get(data, "fetch.enableFetch", "") && !data.submitSelectedRows;',
    },
    {
        label: 'Submit Selected Rows',
        type: 'checkbox',
        input: true,
        key: 'submitSelectedRows',
        weight: 800,
        defaultValue: false,
        tooltip: 'When enabled, the data of the selected rows will be submitted to the server',
        customConditional: 'show = _.get(data, "fetch.enableFetch", false)'
    }
];
